import { render, staticRenderFns } from "./WhatsappHistory.vue?vue&type=template&id=1de9ab8f"
import script from "./WhatsappHistory.vue?vue&type=script&lang=js"
export * from "./WhatsappHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports